import { LexerMatcherLibrary } from "../../../text/lexer/LexerMatcherLibrary";
import { RegExpUtility } from "../../../text/RegExpUtility";
import { ConstantExpression } from "../../expressions/ConstantExpression";
import { ConstantExpressionFactory } from "../../expressions/ConstantExpressionFactory";
import { RJExpressionNode } from "../../expressions/RJExpressionNode";
import { RJToken } from "../../expressions/RJToken";
import { RJParser } from "../../RJParser";

export enum LomaConstantTypeNames
{
  NUMBER
}
 
export class LomaConstantExpressionFactory extends ConstantExpressionFactory
{
  static readonly NUMBER_MATCHER = LexerMatcherLibrary.NUMBER_MATCHER;
  static readonly constantTypes:string[] =  
  [ 
    LomaConstantExpressionFactory.NUMBER_MATCHER.type
  ];

  static readonly constantTypeMatcher = 
    RegExpUtility.createMatcherFromCombiningWords( LomaConstantExpressionFactory.constantTypes, true );
   

  create( parser:RJParser, nodes:RJExpressionNode[], index:number ):ConstantExpression<any>   
  {
    let node = nodes[ index ];

    if ( node.isToken( LomaConstantExpressionFactory.NUMBER_MATCHER.type ) )
    {
      let token = nodes[ index ] as RJToken;
      let numberExpression = new ConstantExpression<number>( parser, node.sourceRange );

      numberExpression.setConstant( LomaConstantTypeNames[ LomaConstantTypeNames.NUMBER ] + "", parseFloat( token.match ) );

      return numberExpression;
    }

    return null;
  }
}